import { Col, List, Row, Typography } from 'antd';
import React from 'react';

const Education = ({ Data, i18 }) => {
  const education = Data.education.filter(i => i.display != false);
  console.log(education)

  return (
    <React.Fragment>
      <div className="section" id="experience">
        <Row>
          <Col span={24}>
            <Typography.Title level={4} style={{ textAlign: 'center' }}>
              {i18.TIT_EDUCATION}
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Typography.Title
              level={5}
              style={{
                textAlign: 'center',
                marginBottom: '2rem',
                color: 'darkgray',
              }}
            >
              <hr />
            </Typography.Title>
          </Col>
          <Col span={24}>
            {/* <Timeline items={timelineItems} /> */}
            <List
              dataSource={education}
              grid={{ column: 3 }}
              renderItem={(item) => (
                <List.Item>
                  <Row style={{ width: '100%' }}>
                    <Col span={24}>
                      <Typography.Text strong>
                        {item.institution}
                      </Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Typography.Text type="primary">
                        {item.from} - {item.to}
                      </Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Typography.Text>{item.degree}</Typography.Text>
                    </Col>
                    <Col span={24}>
                      <List
                        size="small"
                        split={false}
                        dataSource={item.certificate}
                        renderItem={(subItem) =>
                          subItem.title && subItem.value ? (
                            <List.Item>
                              <Typography.Text
                                style={{ fontSize: 12 }}
                              >
                                <strong>{subItem.title}: </strong>
                                {subItem.value}
                              </Typography.Text>
                            </List.Item>
                          ) : ' '
                        }
                      />
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </Col>
        </Row>
      </div>
    </React.Fragment >
  );
};

export default Education;
